import React from 'react';

interface ToastProps {
  message: string | null;
}

/**
 * Einfache Toast-Benachrichtigung. Wird von App.tsx verwendet.
 * Zeigt message an, wenn gesetzt; sonst nichts.
 */
export const Toast: React.FC<ToastProps> = ({ message }) => {
  if (!message) return null;
  return <div className="toast-notification">{message}</div>;
};
